import { request } from '@/utils/request'

export default {
  getDictOptions: (params, loading) => {
    return request('/api/dict/use/codelist', params, loading)
  },
  firmConfigurationEdit: (params, loading) => {
    return request('/api/firmcertificationinformation/edit', params, loading)
  },
  firmConfiguration: (params, loading) => {
    return request('/api/firmcertificationinformation/detail', params, loading)
  },
  exportStatusApi: (params, loading) => {
    return request('/api/firm/export/status', params, loading)
  },
  uploadImg: (params, loading) => { // 上传图片
    return request('/api/upload/min', params, loading)
  },
  login: (params, loading) => { // 登录
    return request('/api/rl/login', params, loading)
  },
  loginOut: (params, loading) => { // 退出
    return request('/api/rl/logout', params, loading)
  },
  adminRepasswd: (params, loading) => { // 管理员重置用户密码
    return request('/api/user/repasswd', params, loading)
  },
  repasswd: (params, loading) => { // 重置用户密码
    return request('/api/user/update/passwd', params, loading)
  },
  setNewPassword: (params, loading) => { // 修改密码
    return request('/api/user/findpassword', params, loading)
  },
  register: (params, loading) => { // 注册
    return request('/api/rl/register', params, loading)
  },
  getCode: (params, loading) => { // 获取手机验证码
    return request('/api/cm/code/get', params, loading)
  },
  checkCode: (params, loading) => { // 核验手机验证码
    return request('/api/cm/code/check', params, loading)
  },
  getUserInfo: (params, loading) => { // 获取用户信息
    return request('/api/user/info', params, loading)
  },
  updateUserInfo: (params, loading) => { // 更新用户信息
    return request('/api/user/update/info', params, loading)
  },
  updatePhone: (params, loading) => { // 更新手机
    return request('/api/user/update/mobile', params, loading)
  },
  sysuser: (params, loading) => { // 系统用户分页列表
    return request('/api/user/userlist', params, loading)
  },
  addSysuser: (params, loading) => { // 新建系统用户
    return request('/api/user/adduser', params, loading)
  },
  delSysuser: (params, loading) => { // 删除系统用户
    return request('/api/user/delete', params, loading)
  },
  handoverSysuser: (params, loading) => { // 系统用户交接
    return request('/api/userfirm/handoveruser', params, loading)
  },
  editSysuser: (params, loading) => { // 编辑用户
    return request('/api/user/updateuser', params, loading)
  },
  getRoleList: () => { // 获取角色信息
    return request('/api/sysrole/rolename')
  },
  dataList: (params, loading) => { // 数据字典分页列表
    return request('/api/sysdict/page', params, loading)
  },
  addDataDict: (params, loading) => { // 新增字典
    return request('/api/sysdict/create', params, loading)
  },
  updateDataDict: (params, loading) => { // 修改字典
    return request('/api/sysdict/update', params, loading)
  },
  delDataDict: (params, loading) => { // 删除字典
    return request('/api/sysdict/delete', params, loading)
  },
  dataDetailList: (params, loading) => { // 字典详情/分页
    return request('/api/sysdictdetails/page', params, loading)
  },
  addDataDetailDict: (params, loading) => { // 字典详情/新增
    return request('/api/sysdict/detail/create', params, loading)
  },
  // delDataDetailDict: (params, loading) => { // 字典详情/删除
  //   return request('/api/sysdictdetails/delete', params, loading)
  // },
  editDataDetailDict: (params, loading) => { // 字典详情/修改
    return request('/api/sysdictdetails/update', params, loading)
  },
  getManageList: (params, loading) => { // 客户管理分页
    return request('/api/firm/query', params, loading)
  },
  userDetail: (params, loading) => { // 客户详情
    return request('/api/firm/details', params, loading)
  },
  exportData: (params, loading) => { // 数据导出
    return request('/api/firm/openexport', params, loading)
  },
  topUp: (params, loading) => { // 充值
    return request('/api/firm/topup', params, loading)
  },
  userDetailHardware: (params, loading) => { // 客户详情 / 硬件坐席
    return request('/api/producthardwaretable/hardware', params, loading)
  },
  userDetailProduct: (params, loading) => { // 客户详情 / 拓客、crm
    return request('/api/productcloudplatform/product', params, loading)
  },
  userDetailCall: (params, loading) => { // 客户详情 / 智能外呼
    return request('/api/firmproductrobot/robot', params, loading)
  },
  userDetailCallEdit: (params, loading) => { // 客户详情 / 智能外呼 / 编辑
    return request('/api/firmproductrobot/update', params, loading)
  },
  userDetailSelectuser: (params, loading) => { // 客户详情(系统用户)/交接人下拉框
    return request('/api/firmcertificationinformation/selectuser', params, loading)
  },
  changeFirm: (params, loading) => { // 客户详情/交接人确定事件
    return request('/api/userfirm/handoverfirm', params, loading)
  },
  disableUser: (params, loading) => { // 禁用
    return request('/api/firm/disable', params, loading)
  },
  statUser: (params, loading) => { // 启用
    return request('/api/firm/startfirm', params, loading)
  },
  openUser: (params, loading) => { // 注册开户
    return request('/api/firmcertificationinformation/registered', params, loading)
  },
  selectUser: (params, loading) => { // 注册开户/查询销售
    return request('/api/firmcertificationinformation/selectuser', params, loading)
  },
  menuPage: (params, loading) => { // 菜单权限/列表
    return request('/api/sysmenu/page', params, loading)
  },
  createMenu: (params, loading) => { // 菜单权限/增加
    return request('/api/sysmenu/create', params, loading)
  },
  deleteMenu: (params, loading) => { // 菜单权限/删除
    return request('/api/sysmenu/delete', params, loading)
  },
  customPage: (params, loading) => { // 菜单权限/删除
    return request('/api/custom/page', params, loading)
  },
  taskCreat: (params, loading) => { // 添加任务
    return request('/api/job/create', params, loading)
  },
  taskList: (params, loading) => { // 任务分页
    return request('/api/job/page', params, loading)
  },
  checkCron: (params, loading) => { // 检查cron表达式
    return request('/api/job/ckcron', params, loading)
  },
  delTask: (params, loading) => { // 删除任务
    return request('/api/job/delete', params, loading)
  },
  editTask: (params, loading) => { // 修改任务
    return request('/api/job/update', params, loading)
  },
  onceRun: (params, loading) => { // 执行一次
    return request('/api/job/run', params, loading)
  },
  nextRunTime: (params, loading) => { // 获取下次执行时间
    return request('/api/job/nextexe', params, loading)
  },
  logList: (params, loading) => { // 日志分页
    return request('/api/joblog/page', params, loading)
  },
  logDelete: (params, loading) => { // 删除日志
    return request('/api/joblog/delete', params, loading)
  },
  // 高级筛选
  filterConditionGroup: (params, loading) => { // 条件列表
    return request('/api/highSearch/conditionGroup', params, loading)
  },
  filterAddressList: (params, loading) => { // 省市区列表
    return request('/api/highSearch/address', params, loading)
  },
  industryOptions: (params, loading) => { // 所属行业options
    return request('/api/highSearch/belongIndustry', params, loading)
  },
  channelOptions: (params, loading) => { // 所属渠道options
    return request('/api/highSearch/channel', params, loading)
  },
  createDefaultTemplate: (params, loading) => { // 新建模板
    return request('/api/firmsearchcondition/create', params, loading)
  },
  defaultTemplateList: (params, loading) => { // 模板列表
    return request('/api/firmsearchcondition/showlist', params, loading)
  },
  ceditTemplate: (params, loading) => { // 编辑模板
    return request('/api/firmsearchcondition/update', params, loading)
  },
  editOneTemplate: (params, loading) => { // 编辑每一条数据
    return request('/api/firmsearchcondition/show', params, loading)
  },
  deleteTemplate: (params, loading) => { // 删除模板
    return request('/api/firmsearchcondition/delete', params, loading)
  },
  // 数据录入
  creatContact: (params, loading) => { // 添加联系方式
    return request('/api/fetching/addContact', params, loading)
  },
  creatTask: (params, loading) => { // 添加抓取任务
    return request('/api/fetching/addgrab', params, loading)
  },
  manualData: (params, loading) => {
    return request('/api/highSearch/push/add', params, loading)
  },
  batchData: (params, loading) => {
    return request('/api/highSearch/push/count', params, loading)
  },
  isUpdate: (params, loading) => {
    return request('/api/highSearch/push/update', params, loading)
  },
  updateCompany: (params, loading) => {
    return request('/api/highSearch/push/company', params, loading)
  },
  detailService: (params, loading) => {
    return request('/api/firmproductcallinrobot/robot', params, loading)
  },
  detailTextService: (params, loading) => {
    return request('/api/firmproducttextrobot/robot', params, loading)
  },
  updateSetInfo: (params, loading) => {
    return request('/api/firmproductcallinrobot/update', params, loading)
  },
  customerTag: (params, loading) => {
    return request('/api/firmcustomerlabel/list', params, loading)
  },
  customerTagEdit: (params, loading) => {
    return request('/api/firmcustomerlabel/edit', params, loading)
  },
  customerCode: (params, loading) => {
    return request('/api/firmcallincollectionfield/list', params, loading)
  },
  customerCodeEdit: (params, loading) => {
    return request('/api/firmcallincollectionfield/edit', params, loading)
  },
  countryList: (params, loading) => {
    return request('/api/highSearch/country', params, loading)
  },
  lineList: (params, loading) => {
    return request('/api/lineapply/page', params, loading)
  },
  updateStatus: (params, loading) => {
    return request('/api/lineapply/update-status', params, loading)
  },
  getOutToken: (params, loading) => { // 获取外呼token
    return request(`${process.env.SAAS_API}/api/outbound/token`, params, loading)
  },
  wordsList: (params, loading, authCode) => {
    return request(`${process.env.CALL_API}/ai/ai2words/find`, params, loading, 'get', authCode)
  },
  otherLineList: (params, loading, authCode) => { // 线路列表
    return request(`${process.env.CALL_API}/ai/sipsysconfig/${params.pageNum}`, {}, loading, 'get', authCode)
  }
}



// WEBPACK FOOTER //
// ./src/api/other.js